import { render, staticRenderFns } from "./BugTrackerDetailsPage.vue?vue&type=template&id=2c275ceb&scoped=true&"
import script from "./BugTrackerDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./BugTrackerDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./BugTrackerDetailsPage.vue?vue&type=style&index=0&id=2c275ceb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c275ceb",
  null
  
)

export default component.exports